module.exports = __webpack_public_path__ + "img/i_green.1cc6e42c.png";